import { render } from "./packages.vue?vue&type=template&id=c367713a&scoped=true"
import script from "./packages.ts?vue&type=script&lang=ts"
export * from "./packages.ts?vue&type=script&lang=ts"

import "./packages.css?vue&type=style&index=0&id=c367713a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c367713a"

export default script